import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteSpecialDiscount } from './DeleteSpecialDiscount';
import { FormTypeDiscount } from './FormTypeDiscount';
import { FormTypeDiscountDelete } from './FormTypeDiscountDelete';
import { Dialog } from 'primereact/dialog';

export const ModalCrudDiscount = (props) => {

    const {closeDialog,method,modal,name, description,percentage,active,handleInputChange,saveCreateDiscounts,saveUpdateDiscount,saveDeleteDiscount,tittleDiscount,loading
    } = props;

    return (
        <Dialog header={"Catalógo de descuentos"} visible={modal} onHide={closeDialog} closable={true} modal blockScroll className='medium-dialog' >
            {
                (method === "create" )
                ?
                    <FormTypeDiscount
                    button="Crear"
                    {...{ closeDialog,name, description,percentage,active,handleInputChange,methodAction: saveCreateDiscounts,loading}}
                />
                : 
                    (method === "update" )
                    ?
                        <FormTypeDiscount
                        button="Actualizar"
                            {...{ closeDialog,name, description,percentage,active,handleInputChange,methodAction: saveUpdateDiscount,loading }}
                        />
                    : 
                    (method === "delete")
                    ?
                        <FormTypeDiscountDelete
                            {
                                ...{
                                    closeDialog,saveDeleteDiscount,tittleDiscount,loading
                                }
                            }
                        />
                    : ""
            }
        </Dialog>
    )
}
